// For now just a stripe payment
export var CustomerPaymentStatus;
(function (CustomerPaymentStatus) {
    CustomerPaymentStatus["PAID"] = "paid";
    CustomerPaymentStatus["UNPAID"] = "unpaid";
    CustomerPaymentStatus["NO_PAYMENT_REQUIRED"] = "no_payment_required";
})(CustomerPaymentStatus || (CustomerPaymentStatus = {}));
//# sourceMappingURL=customerPayment.js.map